// Import all category data from productsData.js (user-created file)
import {
  antiqueData,
  cakeStandData,
  candleFactoryData,
  candleStandData,
  christmashangingdata,
  christmastreeData,
  candleHolderData,
  jarData,
  pumpkinData,
  vasedata,
  votivesData,
} from "./productsData";

// Merge everything into one flat array with a unique globalId
export const allProducts = [
  ...antiqueData,
  ...cakeStandData,
  ...candleFactoryData,
  ...candleStandData,
  ...christmashangingdata,
  ...christmastreeData,
  ...candleHolderData,
  ...jarData,
  ...pumpkinData,
  ...vasedata,
  ...votivesData,
].map((p, index) => ({ ...p, globalId: index + 1 }));

// Unique category list with counts
export const categoryList = [
  { name: "Antique", data: antiqueData },
  { name: "Cake Stand", data: cakeStandData },
  { name: "Candle Factory", data: candleFactoryData },
  { name: "Candle Stand", data: candleStandData },
  { name: "Christmas Hanging", data: christmashangingdata },
  { name: "Christmas Tree", data: christmastreeData },
  { name: "Candle Holder", data: candleHolderData },
  { name: "Jar", data: jarData },
  { name: "Pumpkin", data: pumpkinData },
  { name: "Vase", data: vasedata },
  { name: "Votives", data: votivesData },
].map((c) => ({
  name: c.name,
  count: c.data.length,
  slug: c.name.toLowerCase().replace(/\s+/g, "-"),
}));

// Helper: get products by category name (case-insensitive)
export const getProductsByCategory = (categoryName) => {
  return allProducts.filter(
    (p) => p.category.toLowerCase() === categoryName.toLowerCase(),
  );
};

// Helper: get single product by globalId
export const getProductById = (globalId) => {
  return allProducts.find((p) => p.globalId === parseInt(globalId));
};
const optimizeUrl = (url) => {
  if (!url || !url.includes("res.cloudinary.com")) return url;
  return url.replace("/upload/", "/upload/q_auto,f_auto,/");
};

// 6 featured categories for Home page cards
export const homepageCategories = [
  {
    name: "Antique",
    data: antiqueData,
    image: optimizeUrl(antiqueData[0]?.imageUrl),
  },
  {
    name: "Votives",
    data: votivesData,
    image: optimizeUrl(votivesData[0]?.imageUrl),
  },
  { name: "Vase", data: vasedata, image: optimizeUrl(vasedata[0]?.imageUrl) },
  {
    name: "Candle Stand",
    data: candleStandData,
    image: optimizeUrl(candleStandData[0]?.imageUrl),
  },
  {
    name: "Christmas Hanging",
    data: christmashangingdata,
    image: optimizeUrl(christmashangingdata[0]?.imageUrl),
  },
  {
    name: "Pumpkin",
    data: pumpkinData,
    image: optimizeUrl(pumpkinData[0]?.imageUrl),
  },
];
